// 国家/地区数据配置 - 第一部分：亚洲地区补充
export const countries = [
	// 原有数据
	{
		iso2: 'CN',
		name: '中国',
		flag: '🇨🇳',
		code: '+86',
		placeholder: '请输入手机号码',
		format: '138 0013 8000',
		maxLength: 11,
		pattern: /^1[3-9]\d{9}$/,
		icon: 'https://flagcdn.com/w40/cn.png'
	},
	{
		iso2: 'US',
		name: '美国',
		flag: '🇺🇸',
		code: '+1',
		placeholder: 'Enter phone number',
		format: '(555) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/us.png'
	},
	{
		iso2: 'HK',
		name: '香港',
		flag: '🇭🇰',
		code: '+852',
		placeholder: '请输入手机号码',
		format: '9123 4567',
		maxLength: 8,
		pattern: /^[5-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/hk.png'
	},
	{
		iso2: 'TW',
		name: '台湾',
		flag: '🇹🇼',
		code: '+886',
		placeholder: '请输入手机号码',
		format: '0912 345 678',
		maxLength: 10,
		pattern: /^09\d{8}$/,
		icon: 'https://flagcdn.com/w40/tw.png'
	},
	{
		iso2: 'JP',
		name: '日本',
		flag: '🇯🇵',
		code: '+81',
		placeholder: '電話番号を入力',
		format: '90 1234 5678',
		maxLength: 11,
		pattern: /^[789]0\d{8}$/,
		icon: 'https://flagcdn.com/w40/jp.png'
	},
	{
		iso2: 'KR',
		name: '韩国',
		flag: '🇰🇷',
		code: '+82',
		placeholder: '전화번호 입력',
		format: '010 1234 5678',
		maxLength: 11,
		pattern: /^010\d{8}$/,
		icon: 'https://flagcdn.com/w40/kr.png'
	},
	{
		iso2: 'GB',
		name: '英国',
		flag: '🇬🇧',
		code: '+44',
		placeholder: 'Enter phone number',
		format: '7700 900123',
		maxLength: 10,
		pattern: /^7\d{9}$/,
		icon: 'https://flagcdn.com/w40/gb.png'
	},
	{
		iso2: 'DE',
		name: '德国',
		flag: '🇩🇪',
		code: '+49',
		placeholder: 'Telefonnummer eingeben',
		format: '151 12345678',
		maxLength: 11,
		pattern: /^1[5-7]\d{9}$/,
		icon: 'https://flagcdn.com/w40/de.png'
	},
	{
		iso2: 'FR',
		name: '法国',
		flag: '🇫🇷',
		code: '+33',
		placeholder: 'Entrez le numéro',
		format: '6 12 34 56 78',
		maxLength: 10,
		pattern: /^[67]\d{8}$/,
		icon: 'https://flagcdn.com/w40/fr.png'
	},
	{
		iso2: 'SG',
		name: '新加坡',
		flag: '🇸🇬',
		code: '+65',
		placeholder: 'Enter phone number',
		format: '9123 4567',
		maxLength: 8,
		pattern: /^[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sg.png'
	},
	{
		iso2: 'MY',
		name: '马来西亚',
		flag: '🇲🇾',
		code: '+60',
		placeholder: 'Masukkan nombor telefon',
		format: '12 345 6789',
		maxLength: 10,
		pattern: /^1[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/my.png'
	},
	{
		iso2: 'TH',
		name: '泰国',
		flag: '🇹🇭',
		code: '+66',
		placeholder: 'ป้อนหมายเลขโทรศัพท์',
		format: '81 234 5678',
		maxLength: 9,
		pattern: /^[689]\d{8}$/,
		icon: 'https://flagcdn.com/w40/th.png'
	},
	{
		iso2: 'VN',
		name: '越南',
		flag: '🇻🇳',
		code: '+84',
		placeholder: 'Nhập số điện thoại',
		format: '91 234 5678',
		maxLength: 10,
		pattern: /^[35789]\d{8}$/,
		icon: 'https://flagcdn.com/w40/vn.png'
	},
	{
		iso2: 'ID',
		name: '印度尼西亚',
		flag: '🇮🇩',
		code: '+62',
		placeholder: 'Masukkan nomor telepon',
		format: '812 3456 7890',
		maxLength: 11,
		pattern: /^8\d{9,10}$/,
		icon: 'https://flagcdn.com/w40/id.png'
	},
	{
		iso2: 'PH',
		name: '菲律宾',
		flag: '🇵🇭',
		code: '+63',
		placeholder: 'Enter phone number',
		format: '917 123 4567',
		maxLength: 10,
		pattern: /^9\d{9}$/,
		icon: 'https://flagcdn.com/w40/ph.png'
	},
	{
		iso2: 'IN',
		name: '印度',
		flag: '🇮🇳',
		code: '+91',
		placeholder: 'फ़ोन नंबर दर्ज करें',
		format: '98765 43210',
		maxLength: 10,
		pattern: /^[6-9]\d{9}$/,
		icon: 'https://flagcdn.com/w40/in.png'
	},
	{
		iso2: 'AU',
		name: '澳大利亚',
		flag: '🇦🇺',
		code: '+61',
		placeholder: 'Enter phone number',
		format: '412 345 678',
		maxLength: 9,
		pattern: /^4\d{8}$/,
		icon: 'https://flagcdn.com/w40/au.png'
	},
	{
		iso2: 'CA',
		name: '加拿大',
		flag: '🇨🇦',
		code: '+1',
		placeholder: 'Enter phone number',
		format: '(555) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/ca.png'
	},
	{
		iso2: 'RU',
		name: '俄罗斯',
		flag: '🇷🇺',
		code: '+7',
		placeholder: 'Введите номер телефона',
		format: '912 345 67 89',
		maxLength: 10,
		pattern: /^9\d{9}$/,
		icon: 'https://flagcdn.com/w40/ru.png'
	},
	{
		iso2: 'BR',
		name: '巴西',
		flag: '🇧🇷',
		code: '+55',
		placeholder: 'Digite o número',
		format: '11 91234 5678',
		maxLength: 11,
		pattern: /^[1-9]\d{10}$/,
		icon: 'https://flagcdn.com/w40/br.png'
	},
	// 亚洲地区补充
	{
		iso2: 'MO',
		name: '澳门',
		flag: '🇲🇴',
		code: '+853',
		placeholder: '请输入手机号码',
		format: '6123 4567',
		maxLength: 8,
		pattern: /^6\d{7}$/,
		icon: 'https://flagcdn.com/w40/mo.png'
	},
	{
		iso2: 'KH',
		name: '柬埔寨',
		flag: '🇰🇭',
		code: '+855',
		placeholder: 'បញ្ចូលលេខទូរស័ព្ទ',
		format: '12 345 678',
		maxLength: 9,
		pattern: /^[1-9]\d{7,8}$/,
		icon: 'https://flagcdn.com/w40/kh.png'
	},
	{
		iso2: 'LA',
		name: '老挝',
		flag: '🇱🇦',
		code: '+856',
		placeholder: 'ປ້ອນເບີໂທລະສັບ',
		format: '20 1234 5678',
		maxLength: 10,
		pattern: /^20\d{8}$/,
		icon: 'https://flagcdn.com/w40/la.png'
	},
	{
		iso2: 'MM',
		name: '缅甸',
		flag: '🇲🇲',
		code: '+95',
		placeholder: 'ဖုန်းနံပါတ်ထည့်ပါ',
		format: '9 1234 5678',
		maxLength: 10,
		pattern: /^9\d{9}$/,
		icon: 'https://flagcdn.com/w40/mm.png'
	},
	{
		iso2: 'BD',
		name: '孟加拉国',
		flag: '🇧🇩',
		code: '+880',
		placeholder: 'ফোন নম্বর লিখুন',
		format: '171 234 5678',
		maxLength: 11,
		pattern: /^1[3-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/bd.png'
	},
	{
		iso2: 'PK',
		name: '巴基斯坦',
		flag: '🇵🇰',
		code: '+92',
		placeholder: 'فون نمبر درج کریں',
		format: '300 1234567',
		maxLength: 10,
		pattern: /^3\d{9}$/,
		icon: 'https://flagcdn.com/w40/pk.png'
	},
	{
		iso2: 'LK',
		name: '斯里兰卡',
		flag: '🇱🇰',
		code: '+94',
		placeholder: 'දුරකථන අංකය ඇතුළත් කරන්න',
		format: '71 234 5678',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/lk.png'
	},
	{
		iso2: 'NP',
		name: '尼泊尔',
		flag: '🇳🇵',
		code: '+977',
		placeholder: 'फोन नम्बर प्रविष्ट गर्नुहोस्',
		format: '98 1234 5678',
		maxLength: 10,
		pattern: /^9[78]\d{8}$/,
		icon: 'https://flagcdn.com/w40/np.png'
	},
	{
		iso2: 'BT',
		name: '不丹',
		flag: '🇧🇹',
		code: '+975',
		placeholder: 'ཁ་པར་ཨང་གྲངས་འབེབས་པ།',
		format: '17 123 456',
		maxLength: 8,
		pattern: /^[17]\d{7}$/,
		icon: 'https://flagcdn.com/w40/bt.png'
	},
	{
		iso2: 'MV',
		name: '马尔代夫',
		flag: '🇲🇻',
		code: '+960',
		placeholder: 'ފޯން ނަންބަރު ލިޔުއްވާ',
		format: '7 123 456',
		maxLength: 7,
		pattern: /^[79]\d{6}$/,
		icon: 'https://flagcdn.com/w40/mv.png'
	},
	{
		iso2: 'AF',
		name: '阿富汗',
		flag: '🇦🇫',
		code: '+93',
		placeholder: 'د تلیفون شمېره ورننوځئ',
		format: '70 123 4567',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/af.png'
	},
	{
		iso2: 'UZ',
		name: '乌兹别克斯坦',
		flag: '🇺🇿',
		code: '+998',
		placeholder: 'Telefon raqamini kiriting',
		format: '90 123 45 67',
		maxLength: 9,
		pattern: /^[679]\d{8}$/,
		icon: 'https://flagcdn.com/w40/uz.png'
	},
	{
		iso2: 'KZ',
		name: '哈萨克斯坦',
		flag: '🇰🇿',
		code: '+7',
		placeholder: 'Телефон нөмірін енгізіңіз',
		format: '701 234 5678',
		maxLength: 10,
		pattern: /^7[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/kz.png'
	},
	{
		iso2: 'KG',
		name: '吉尔吉斯斯坦',
		flag: '🇰🇬',
		code: '+996',
		placeholder: 'Телефон номерин киргизиңиз',
		format: '550 123 456',
		maxLength: 9,
		pattern: /^[579]\d{8}$/,
		icon: 'https://flagcdn.com/w40/kg.png'
	},
	{
		iso2: 'TJ',
		name: '塔吉克斯坦',
		flag: '🇹🇯',
		code: '+992',
		placeholder: 'Рақами телефонро ворид кунед',
		format: '90 123 4567',
		maxLength: 9,
		pattern: /^[39]\d{8}$/,
		icon: 'https://flagcdn.com/w40/tj.png'
	},
	{
		iso2: 'TM',
		name: '土库曼斯坦',
		flag: '🇹🇲',
		code: '+993',
		placeholder: 'Telefon belgisini giriziň',
		format: '65 123 456',
		maxLength: 8,
		pattern: /^6[1-5]\d{6}$/,
		icon: 'https://flagcdn.com/w40/tm.png'
	},
	{
		iso2: 'MN',
		name: '蒙古国',
		flag: '🇲🇳',
		code: '+976',
		placeholder: 'Утасны дугаар оруулна уу',
		format: '9999 1234',
		maxLength: 8,
		pattern: /^[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mn.png'
	},
	{
		iso2: 'BN',
		name: '文莱',
		flag: '🇧🇳',
		code: '+673',
		placeholder: 'Masukkan nombor telefon',
		format: '712 3456',
		maxLength: 7,
		pattern: /^[78]\d{6}$/,
		icon: 'https://flagcdn.com/w40/bn.png'
	},
	{
		iso2: 'TL',
		name: '东帝汶',
		flag: '🇹🇱',
		code: '+670',
		placeholder: 'Hakerek númeru telefone',
		format: '7712 3456',
		maxLength: 8,
		pattern: /^7[7-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/tl.png'
	},
	// 欧洲地区手机号码配置

	{
		iso2: 'IT',
		name: '意大利',
		flag: '🇮🇹',
		code: '+39',
		placeholder: 'Inserisci il numero',
		format: '333 123 4567',
		maxLength: 10,
		pattern: /^3[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/it.png'
	},
	{
		iso2: 'ES',
		name: '西班牙',
		flag: '🇪🇸',
		code: '+34',
		placeholder: 'Introduce el número',
		format: '612 34 56 78',
		maxLength: 9,
		pattern: /^[67]\d{8}$/,
		icon: 'https://flagcdn.com/w40/es.png'
	},
	{
		iso2: 'PT',
		name: '葡萄牙',
		flag: '🇵🇹',
		code: '+351',
		placeholder: 'Introduza o número',
		format: '911 234 567',
		maxLength: 9,
		pattern: /^9[1236]\d{7}$/,
		icon: 'https://flagcdn.com/w40/pt.png'
	},
	{
		iso2: 'NL',
		name: '荷兰',
		flag: '🇳🇱',
		code: '+31',
		placeholder: 'Voer telefoonnummer in',
		format: '6 12 34 56 78',
		maxLength: 9,
		pattern: /^6\d{8}$/,
		icon: 'https://flagcdn.com/w40/nl.png'
	},
	{
		iso2: 'BE',
		name: '比利时',
		flag: '🇧🇪',
		code: '+32',
		placeholder: 'Voer telefoonnummer in',
		format: '470 12 34 56',
		maxLength: 9,
		pattern: /^4[6-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/be.png'
	},
	{
		iso2: 'LU',
		name: '卢森堡',
		flag: '🇱🇺',
		code: '+352',
		placeholder: 'Gitt Telefonnummer an',
		format: '691 123 456',
		maxLength: 9,
		pattern: /^6[9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/lu.png'
	},
	{
		iso2: 'CH',
		name: '瑞士',
		flag: '🇨🇭',
		code: '+41',
		placeholder: 'Telefonnummer eingeben',
		format: '78 123 45 67',
		maxLength: 9,
		pattern: /^7[5-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ch.png'
	},
	{
		iso2: 'AT',
		name: '奥地利',
		flag: '🇦🇹',
		code: '+43',
		placeholder: 'Telefonnummer eingeben',
		format: '664 123 4567',
		maxLength: 10,
		pattern: /^6[5-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/at.png'
	},
	{
		iso2: 'IE',
		name: '爱尔兰',
		flag: '🇮🇪',
		code: '+353',
		placeholder: 'Enter phone number',
		format: '85 123 4567',
		maxLength: 9,
		pattern: /^8[35-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ie.png'
	},
	{
		iso2: 'IS',
		name: '冰岛',
		flag: '🇮🇸',
		code: '+354',
		placeholder: 'Sláðu inn símanúmer',
		format: '6 12 34 56',
		maxLength: 7,
		pattern: /^[678]\d{6}$/,
		icon: 'https://flagcdn.com/w40/is.png'
	},
	// 北欧
	{
		iso2: 'NO',
		name: '挪威',
		flag: '🇳🇴',
		code: '+47',
		placeholder: 'Skriv inn telefonnummer',
		format: '412 34 567',
		maxLength: 8,
		pattern: /^[49]\d{7}$/,
		icon: 'https://flagcdn.com/w40/no.png'
	},
	{
		iso2: 'SE',
		name: '瑞典',
		flag: '🇸🇪',
		code: '+46',
		placeholder: 'Ange telefonnummer',
		format: '70 123 45 67',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/se.png'
	},
	{
		iso2: 'DK',
		name: '丹麦',
		flag: '🇩🇰',
		code: '+45',
		placeholder: 'Indtast telefonnummer',
		format: '12 34 56 78',
		maxLength: 8,
		pattern: /^[2-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/dk.png'
	},
	{
		iso2: 'FI',
		name: '芬兰',
		flag: '🇫🇮',
		code: '+358',
		placeholder: 'Syötä puhelinnumero',
		format: '40 123 4567',
		maxLength: 9,
		pattern: /^[4-5]\d{8}$/,
		icon: 'https://flagcdn.com/w40/fi.png'
	},
	// 东欧
	{
		iso2: 'PL',
		name: '波兰',
		flag: '🇵🇱',
		code: '+48',
		placeholder: 'Wprowadź numer telefonu',
		format: '512 123 456',
		maxLength: 9,
		pattern: /^[4-8]\d{8}$/,
		icon: 'https://flagcdn.com/w40/pl.png'
	},
	{
		iso2: 'CZ',
		name: '捷克',
		flag: '🇨🇿',
		code: '+420',
		placeholder: 'Zadejte telefonní číslo',
		format: '601 123 456',
		maxLength: 9,
		pattern: /^[6-7]\d{8}$/,
		icon: 'https://flagcdn.com/w40/cz.png'
	},
	{
		iso2: 'SK',
		name: '斯洛伐克',
		flag: '🇸🇰',
		code: '+421',
		placeholder: 'Zadajte telefónne číslo',
		format: '901 123 456',
		maxLength: 9,
		pattern: /^9[0-5]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sk.png'
	},
	{
		iso2: 'HU',
		name: '匈牙利',
		flag: '🇭🇺',
		code: '+36',
		placeholder: 'Adja meg a telefonszámot',
		format: '30 123 4567',
		maxLength: 9,
		pattern: /^[237]\d{8}$/,
		icon: 'https://flagcdn.com/w40/hu.png'
	},
	{
		iso2: 'RO',
		name: '罗马尼亚',
		flag: '🇷🇴',
		code: '+40',
		placeholder: 'Introduceți numărul de telefon',
		format: '721 123 456',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ro.png'
	},
	{
		iso2: 'BG',
		name: '保加利亚',
		flag: '🇧🇬',
		code: '+359',
		placeholder: 'Въведете телефонен номер',
		format: '88 123 4567',
		maxLength: 9,
		pattern: /^[89]\d{8}$/,
		icon: 'https://flagcdn.com/w40/bg.png'
	},
	{
		iso2: 'HR',
		name: '克罗地亚',
		flag: '🇭🇷',
		code: '+385',
		placeholder: 'Unesite broj telefona',
		format: '91 123 4567',
		maxLength: 9,
		pattern: /^9[1-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/hr.png'
	},
	{
		iso2: 'SI',
		name: '斯洛文尼亚',
		flag: '🇸🇮',
		code: '+386',
		placeholder: 'Vnesite telefonsko številko',
		format: '31 123 456',
		maxLength: 8,
		pattern: /^[3-7]\d{7}$/,
		icon: 'https://flagcdn.com/w40/si.png'
	},
	{
		iso2: 'BA',
		name: '波斯尼亚和黑塞哥维那',
		flag: '🇧🇦',
		code: '+387',
		placeholder: 'Unesite broj telefona',
		format: '61 123 456',
		maxLength: 8,
		pattern: /^6[0-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/ba.png'
	},
	{
		iso2: 'RS',
		name: '塞尔维亚',
		flag: '🇷🇸',
		code: '+381',
		placeholder: 'Унесите број телефона',
		format: '62 123 4567',
		maxLength: 9,
		pattern: /^6[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/rs.png'
	},
	{
		iso2: 'ME',
		name: '黑山',
		flag: '🇲🇪',
		code: '+382',
		placeholder: 'Unesite broj telefona',
		format: '67 123 456',
		maxLength: 8,
		pattern: /^6[7-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/me.png'
	},
	{
		iso2: 'MK',
		name: '北马其顿',
		flag: '🇲🇰',
		code: '+389',
		placeholder: 'Внесете телефонски број',
		format: '70 123 456',
		maxLength: 8,
		pattern: /^7[0-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/mk.png'
	},
	// 第三部分：欧洲续、中东、非洲地区
	{
		iso2: 'AL',
		name: '阿尔巴尼亚',
		flag: '🇦🇱',
		code: '+355',
		placeholder: 'Shkruani numrin e telefonit',
		format: '67 123 4567',
		maxLength: 9,
		pattern: /^6[7-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/al.png'
	},
	{
		iso2: 'GR',
		name: '希腊',
		flag: '🇬🇷',
		code: '+30',
		placeholder: 'Εισάγετε αριθμό τηλεφώνου',
		format: '691 234 5678',
		maxLength: 10,
		pattern: /^6[9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/gr.png'
	},
	{
		iso2: 'CY',
		name: '塞浦路斯',
		flag: '🇨🇾',
		code: '+357',
		placeholder: 'Εισάγετε αριθμό τηλεφώνου',
		format: '99 123 456',
		maxLength: 8,
		pattern: /^9[5-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/cy.png'
	},
	{
		iso2: 'MT',
		name: '马耳他',
		flag: '🇲🇹',
		code: '+356',
		placeholder: 'Daħħal in-numru tat-telefon',
		format: '9912 3456',
		maxLength: 8,
		pattern: /^[79]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mt.png'
	},
	{
		iso2: 'EE',
		name: '爱沙尼亚',
		flag: '🇪🇪',
		code: '+372',
		placeholder: 'Sisestage telefoninumber',
		format: '512 3456',
		maxLength: 7,
		pattern: /^[5-8]\d{6,7}$/,
		icon: 'https://flagcdn.com/w40/ee.png'
	},
	{
		iso2: 'LV',
		name: '拉脱维亚',
		flag: '🇱🇻',
		code: '+371',
		placeholder: 'Ievadiet tālruņa numuru',
		format: '2123 4567',
		maxLength: 8,
		pattern: /^2\d{7}$/,
		icon: 'https://flagcdn.com/w40/lv.png'
	},
	{
		iso2: 'LT',
		name: '立陶宛',
		flag: '🇱🇹',
		code: '+370',
		placeholder: 'Įveskite telefono numerį',
		format: '612 34567',
		maxLength: 8,
		pattern: /^6\d{7}$/,
		icon: 'https://flagcdn.com/w40/lt.png'
	},
	{
		iso2: 'BY',
		name: '白俄罗斯',
		flag: '🇧🇾',
		code: '+375',
		placeholder: 'Увядзіце нумар тэлефона',
		format: '29 123 45 67',
		maxLength: 9,
		pattern: /^[2-4][4-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/by.png'
	},
	{
		iso2: 'UA',
		name: '乌克兰',
		flag: '🇺🇦',
		code: '+380',
		placeholder: 'Введіть номер телефону',
		format: '50 123 4567',
		maxLength: 9,
		pattern: /^[3-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ua.png'
	},
	{
		iso2: 'MD',
		name: '摩尔多瓦',
		flag: '🇲🇩',
		code: '+373',
		placeholder: 'Introduceți numărul de telefon',
		format: '69 123 456',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/md.png'
	},

	// 中东地区
	{
		iso2: 'TR',
		name: '土耳其',
		flag: '🇹🇷',
		code: '+90',
		placeholder: 'Telefon numarasını girin',
		format: '532 123 45 67',
		maxLength: 10,
		pattern: /^5[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/tr.png'
	},
	{
		iso2: 'IL',
		name: '以色列',
		flag: '🇮🇱',
		code: '+972',
		placeholder: 'הזן מספר טלפון',
		format: '50 123 4567',
		maxLength: 9,
		pattern: /^5[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/il.png'
	},
	{
		iso2: 'PS',
		name: '巴勒斯坦',
		flag: '🇵🇸',
		code: '+970',
		placeholder: 'أدخل رقم الهاتف',
		format: '59 123 4567',
		maxLength: 9,
		pattern: /^5[69]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ps.png'
	},
	{
		iso2: 'LB',
		name: '黎巴嫩',
		flag: '🇱🇧',
		code: '+961',
		placeholder: 'أدخل رقم الهاتف',
		format: '70 123 456',
		maxLength: 8,
		pattern: /^[37]\d{7}$/,
		icon: 'https://flagcdn.com/w40/lb.png'
	},
	{
		iso2: 'SY',
		name: '叙利亚',
		flag: '🇸🇾',
		code: '+963',
		placeholder: 'أدخل رقم الهاتف',
		format: '93 123 4567',
		maxLength: 9,
		pattern: /^9[3-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sy.png'
	},
	{
		iso2: 'JO',
		name: '约旦',
		flag: '🇯🇴',
		code: '+962',
		placeholder: 'أدخل رقم الهاتف',
		format: '79 123 4567',
		maxLength: 9,
		pattern: /^7[7-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/jo.png'
	},
	{
		iso2: 'IQ',
		name: '伊拉克',
		flag: '🇮🇶',
		code: '+964',
		placeholder: 'أدخل رقم الهاتف',
		format: '750 123 4567',
		maxLength: 10,
		pattern: /^7[5-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/iq.png'
	},
	{
		iso2: 'KW',
		name: '科威特',
		flag: '🇰🇼',
		code: '+965',
		placeholder: 'أدخل رقم الهاتف',
		format: '9123 4567',
		maxLength: 8,
		pattern: /^[569]\d{7}$/,
		icon: 'https://flagcdn.com/w40/kw.png'
	},
	{
		iso2: 'SA',
		name: '沙特阿拉伯',
		flag: '🇸🇦',
		code: '+966',
		placeholder: 'أدخل رقم الهاتف',
		format: '50 123 4567',
		maxLength: 9,
		pattern: /^5[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sa.png'
	},
	{
		iso2: 'BH',
		name: '巴林',
		flag: '🇧🇭',
		code: '+973',
		placeholder: 'أدخل رقم الهاتف',
		format: '3612 3456',
		maxLength: 8,
		pattern: /^[36]\d{7}$/,
		icon: 'https://flagcdn.com/w40/bh.png'
	},
	{
		iso2: 'QA',
		name: '卡塔尔',
		flag: '🇶🇦',
		code: '+974',
		placeholder: 'أدخل رقم الهاتف',
		format: '3312 3456',
		maxLength: 8,
		pattern: /^[3567]\d{7}$/,
		icon: 'https://flagcdn.com/w40/qa.png'
	},
	{
		iso2: 'AE',
		name: '阿联酋',
		flag: '🇦🇪',
		code: '+971',
		placeholder: 'أدخل رقم الهاتف',
		format: '50 123 4567',
		maxLength: 9,
		pattern: /^5[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ae.png'
	},
	{
		iso2: 'OM',
		name: '阿曼',
		flag: '🇴🇲',
		code: '+968',
		placeholder: 'أدخل رقم الهاتف',
		format: '9123 4567',
		maxLength: 8,
		pattern: /^[79]\d{7}$/,
		icon: 'https://flagcdn.com/w40/om.png'
	},
	{
		iso2: 'YE',
		name: '也门',
		flag: '🇾🇪',
		code: '+967',
		placeholder: 'أدخل رقم الهاتف',
		format: '77 123 4567',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ye.png'
	},
	{
		iso2: 'IR',
		name: '伊朗',
		flag: '🇮🇷',
		code: '+98',
		placeholder: 'شماره تلفن را وارد کنید',
		format: '912 345 6789',
		maxLength: 10,
		pattern: /^9[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ir.png'
	},

	// 非洲地区（部分）
	{
		iso2: 'EG',
		name: '埃及',
		flag: '🇪🇬',
		code: '+20',
		placeholder: 'أدخل رقم الهاتف',
		format: '10 1234 5678',
		maxLength: 10,
		pattern: /^1[0-5]\d{8}$/,
		icon: 'https://flagcdn.com/w40/eg.png'
	},
	{
		iso2: 'ZA',
		name: '南非',
		flag: '🇿🇦',
		code: '+27',
		placeholder: 'Enter phone number',
		format: '82 123 4567',
		maxLength: 9,
		pattern: /^[678]\d{8}$/,
		icon: 'https://flagcdn.com/w40/za.png'
	},
	{
		iso2: 'NG',
		name: '尼日利亚',
		flag: '🇳🇬',
		code: '+234',
		placeholder: 'Enter phone number',
		format: '802 123 4567',
		maxLength: 10,
		pattern: /^[789]\d{9}$/,
		icon: 'https://flagcdn.com/w40/ng.png'
	},
	{
		iso2: 'KE',
		name: '肯尼亚',
		flag: '🇰🇪',
		code: '+254',
		placeholder: 'Enter phone number',
		format: '712 345 678',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ke.png'
	},
	{
		iso2: 'GH',
		name: '加纳',
		flag: '🇬🇭',
		code: '+233',
		placeholder: 'Enter phone number',
		format: '24 123 4567',
		maxLength: 9,
		pattern: /^[2-5]\d{8}$/,
		icon: 'https://flagcdn.com/w40/gh.png'
	},
	{
		iso2: 'ET',
		name: '埃塞俄比亚',
		flag: '🇪🇹',
		code: '+251',
		placeholder: 'ስልክ ቁጥር ያስገቡ',
		format: '91 123 4567',
		maxLength: 9,
		pattern: /^9[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/et.png'
	},
	{
		iso2: 'TZ',
		name: '坦桑尼亚',
		flag: '🇹🇿',
		code: '+255',
		placeholder: 'Ingiza nambari ya simu',
		format: '712 345 678',
		maxLength: 9,
		pattern: /^[67]\d{8}$/,
		icon: 'https://flagcdn.com/w40/tz.png'
	},
	{
		iso2: 'UG',
		name: '乌干达',
		flag: '🇺🇬',
		code: '+256',
		placeholder: 'Enter phone number',
		format: '772 123 456',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ug.png'
	},
	{
		iso2: 'MA',
		name: '摩洛哥',
		flag: '🇲🇦',
		code: '+212',
		placeholder: 'أدخل رقم الهاتف',
		format: '612 345 678',
		maxLength: 9,
		pattern: /^[67]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ma.png'
	},
	{
		iso2: 'DZ',
		name: '阿尔及利亚',
		flag: '🇩🇿',
		code: '+213',
		placeholder: 'أدخل رقم الهاتف',
		format: '551 23 45 67',
		maxLength: 9,
		pattern: /^[567]\d{8}$/,
		icon: 'https://flagcdn.com/w40/dz.png'
	},
	{
		iso2: 'TN',
		name: '突尼斯',
		flag: '🇹🇳',
		code: '+216',
		placeholder: 'أدخل رقم الهاتف',
		format: '20 123 456',
		maxLength: 8,
		pattern: /^[2-579]\d{7}$/,
		icon: 'https://flagcdn.com/w40/tn.png'
	},
	{
		iso2: 'LY',
		name: '利比亚',
		flag: '🇱🇾',
		code: '+218',
		placeholder: 'أدخل رقم الهاتف',
		format: '91 123 4567',
		maxLength: 9,
		pattern: /^9[1-6]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ly.png'
	},
	// 第四部分：美洲、大洋洲及其他地区
	{
		iso2: 'MX',
		name: '墨西哥',
		flag: '🇲🇽',
		code: '+52',
		placeholder: 'Ingresa el número',
		format: '55 1234 5678',
		maxLength: 10,
		pattern: /^[1-9]\d{9}$/,
		icon: 'https://flagcdn.com/w40/mx.png'
	},
	{
		iso2: 'GT',
		name: '危地马拉',
		flag: '🇬🇹',
		code: '+502',
		placeholder: 'Ingresa el número',
		format: '5123 4567',
		maxLength: 8,
		pattern: /^[45]\d{7}$/,
		icon: 'https://flagcdn.com/w40/gt.png'
	},
	{
		iso2: 'BZ',
		name: '伯利兹',
		flag: '🇧🇿',
		code: '+501',
		placeholder: 'Enter phone number',
		format: '612 3456',
		maxLength: 7,
		pattern: /^[6]\d{6}$/,
		icon: 'https://flagcdn.com/w40/bz.png'
	},
	{
		iso2: 'SV',
		name: '萨尔瓦多',
		flag: '🇸🇻',
		code: '+503',
		placeholder: 'Ingresa el número',
		format: '7012 3456',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sv.png'
	},
	{
		iso2: 'HN',
		name: '洪都拉斯',
		flag: '🇭🇳',
		code: '+504',
		placeholder: 'Ingresa el número',
		format: '9123 4567',
		maxLength: 8,
		pattern: /^[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/hn.png'
	},
	{
		iso2: 'NI',
		name: '尼加拉瓜',
		flag: '🇳🇮',
		code: '+505',
		placeholder: 'Ingresa el número',
		format: '8123 4567',
		maxLength: 8,
		pattern: /^[578]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ni.png'
	},
	{
		iso2: 'CR',
		name: '哥斯达黎加',
		flag: '🇨🇷',
		code: '+506',
		placeholder: 'Ingresa el número',
		format: '8123 4567',
		maxLength: 8,
		pattern: /^[68]\d{7}$/,
		icon: 'https://flagcdn.com/w40/cr.png'
	},
	{
		iso2: 'PA',
		name: '巴拿马',
		flag: '🇵🇦',
		code: '+507',
		placeholder: 'Ingresa el número',
		format: '6123 4567',
		maxLength: 8,
		pattern: /^[6]\d{7}$/,
		icon: 'https://flagcdn.com/w40/pa.png'
	},
	{
		iso2: 'CU',
		name: '古巴',
		flag: '🇨🇺',
		code: '+53',
		placeholder: 'Ingresa el número',
		format: '5123 4567',
		maxLength: 8,
		pattern: /^5\d{7}$/,
		icon: 'https://flagcdn.com/w40/cu.png'
	},
	{
		iso2: 'JM',
		name: '牙买加',
		flag: '🇯🇲',
		code: '+1876',
		placeholder: 'Enter phone number',
		format: '(876) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/jm.png'
	},
	{
		iso2: 'HT',
		name: '海地',
		flag: '🇭🇹',
		code: '+509',
		placeholder: 'Antre nimewo telefòn',
		format: '34 12 3456',
		maxLength: 8,
		pattern: /^[34]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ht.png'
	},
	{
		iso2: 'DO',
		name: '多米尼加共和国',
		flag: '🇩🇴',
		code: '+1809',
		placeholder: 'Ingresa el número',
		format: '(809) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/do.png'
	},
	{
		iso2: 'PR',
		name: '波多黎各',
		flag: '🇵🇷',
		code: '+1787',
		placeholder: 'Enter phone number',
		format: '(787) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/pr.png'
	},
	{
		iso2: 'TT',
		name: '特立尼达和多巴哥',
		flag: '🇹🇹',
		code: '+1868',
		placeholder: 'Enter phone number',
		format: '(868) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/tt.png'
	},

	// 南美洲
	{
		iso2: 'AR',
		name: '阿根廷',
		flag: '🇦🇷',
		code: '+54',
		placeholder: 'Ingresá el número',
		format: '9 11 1234 5678',
		maxLength: 10,
		pattern: /^9[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ar.png'
	},
	{
		iso2: 'CL',
		name: '智利',
		flag: '🇨🇱',
		code: '+56',
		placeholder: 'Ingresa el número',
		format: '9 1234 5678',
		maxLength: 9,
		pattern: /^9\d{8}$/,
		icon: 'https://flagcdn.com/w40/cl.png'
	},
	{
		iso2: 'CO',
		name: '哥伦比亚',
		flag: '🇨🇴',
		code: '+57',
		placeholder: 'Ingresa el número',
		format: '300 123 4567',
		maxLength: 10,
		pattern: /^3[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/co.png'
	},
	{
		iso2: 'VE',
		name: '委内瑞拉',
		flag: '🇻🇪',
		code: '+58',
		placeholder: 'Ingresa el número',
		format: '412 123 4567',
		maxLength: 10,
		pattern: /^4[0-9]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ve.png'
	},
	{
		iso2: 'GY',
		name: '圭亚那',
		flag: '🇬🇾',
		code: '+592',
		placeholder: 'Enter phone number',
		format: '612 3456',
		maxLength: 7,
		pattern: /^[6]\d{6}$/,
		icon: 'https://flagcdn.com/w40/gy.png'
	},
	{
		iso2: 'SR',
		name: '苏里南',
		flag: '🇸🇷',
		code: '+597',
		placeholder: 'Voer telefoonnummer in',
		format: '712 3456',
		maxLength: 7,
		pattern: /^[67]\d{6}$/,
		icon: 'https://flagcdn.com/w40/sr.png'
	},
	{
		iso2: 'GF',
		name: '法属圭亚那',
		flag: '🇬🇫',
		code: '+594',
		placeholder: 'Entrez le numéro',
		format: '694 12 34 56',
		maxLength: 9,
		pattern: /^6[9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/gf.png'
	},
	{
		iso2: 'UY',
		name: '乌拉圭',
		flag: '🇺🇾',
		code: '+598',
		placeholder: 'Ingresá el número',
		format: '91 123 456',
		maxLength: 8,
		pattern: /^9[1-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/uy.png'
	},
	{
		iso2: 'PY',
		name: '巴拉圭',
		flag: '🇵🇾',
		code: '+595',
		placeholder: 'Ingresa el número',
		format: '961 123 456',
		maxLength: 9,
		pattern: /^9[6-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/py.png'
	},
	{
		iso2: 'BO',
		name: '玻利维亚',
		flag: '🇧🇴',
		code: '+591',
		placeholder: 'Ingresa el número',
		format: '712 34567',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/bo.png'
	},
	{
		iso2: 'PE',
		name: '秘鲁',
		flag: '🇵🇪',
		code: '+51',
		placeholder: 'Ingresa el número',
		format: '912 345 678',
		maxLength: 9,
		pattern: /^9\d{8}$/,
		icon: 'https://flagcdn.com/w40/pe.png'
	},
	{
		iso2: 'EC',
		name: '厄瓜多尔',
		flag: '🇪🇨',
		code: '+593',
		placeholder: 'Ingresa el número',
		format: '99 123 4567',
		maxLength: 9,
		pattern: /^9[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ec.png'
	},

	// 大洋洲
	{
		iso2: 'NZ',
		name: '新西兰',
		flag: '🇳🇿',
		code: '+64',
		placeholder: 'Enter phone number',
		format: '21 123 4567',
		maxLength: 9,
		pattern: /^2[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/nz.png'
	},
	{
		iso2: 'FJ',
		name: '斐济',
		flag: '🇫🇯',
		code: '+679',
		placeholder: 'Enter phone number',
		format: '912 3456',
		maxLength: 7,
		pattern: /^[79]\d{6}$/,
		icon: 'https://flagcdn.com/w40/fj.png'
	},
	{
		iso2: 'PG',
		name: '巴布亚新几内亚',
		flag: '🇵🇬',
		code: '+675',
		placeholder: 'Enter phone number',
		format: '7012 3456',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/pg.png'
	},
	{
		iso2: 'VU',
		name: '瓦努阿图',
		flag: '🇻🇺',
		code: '+678',
		placeholder: 'Enter phone number',
		format: '591 2345',
		maxLength: 7,
		pattern: /^[579]\d{6}$/,
		icon: 'https://flagcdn.com/w40/vu.png'
	},
	{
		iso2: 'NC',
		name: '新喀里多尼亚',
		flag: '🇳🇨',
		code: '+687',
		placeholder: 'Entrez le numéro',
		format: '12 34 56',
		maxLength: 6,
		pattern: /^[789]\d{5}$/,
		icon: 'https://flagcdn.com/w40/nc.png'
	},
	{
		iso2: 'PF',
		name: '法属波利尼西亚',
		flag: '🇵🇫',
		code: '+689',
		placeholder: 'Entrez le numéro',
		format: '87 12 34 56',
		maxLength: 8,
		pattern: /^[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/pf.png'
	},
	{
		iso2: 'WS',
		name: '萨摩亚',
		flag: '🇼🇸',
		code: '+685',
		placeholder: 'Enter phone number',
		format: '72 12345',
		maxLength: 7,
		pattern: /^[7]\d{6}$/,
		icon: 'https://flagcdn.com/w40/ws.png'
	},
	{
		iso2: 'TO',
		name: '汤加',
		flag: '🇹🇴',
		code: '+676',
		placeholder: 'Enter phone number',
		format: '771 2345',
		maxLength: 7,
		pattern: /^[78]\d{6}$/,
		icon: 'https://flagcdn.com/w40/to.png'
	},
	{
		iso2: 'CK',
		name: '库克群岛',
		flag: '🇨🇰',
		code: '+682',
		placeholder: 'Enter phone number',
		format: '12 345',
		maxLength: 5,
		pattern: /^[1-9]\d{4}$/,
		icon: 'https://flagcdn.com/w40/ck.png'
	},
	{
		iso2: 'NU',
		name: '纽埃',
		flag: '🇳🇺',
		code: '+683',
		placeholder: 'Enter phone number',
		format: '1234',
		maxLength: 4,
		pattern: /^\d{4}$/,
		icon: 'https://flagcdn.com/w40/nu.png'
	},
	{
		iso2: 'KI',
		name: '基里巴斯',
		flag: '🇰🇮',
		code: '+686',
		placeholder: 'Enter phone number',
		format: '123 4567',
		maxLength: 8,
		pattern: /^[69]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ki.png'
	},
	{
		iso2: 'NR',
		name: '瑙鲁',
		flag: '🇳🇷',
		code: '+674',
		placeholder: 'Enter phone number',
		format: '555 1234',
		maxLength: 7,
		pattern: /^[45]\d{6}$/,
		icon: 'https://flagcdn.com/w40/nr.png'
	},
	{
		iso2: 'PW',
		name: '帕劳',
		flag: '🇵🇼',
		code: '+680',
		placeholder: 'Enter phone number',
		format: '620 1234',
		maxLength: 7,
		pattern: /^[6-7]\d{6}$/,
		icon: 'https://flagcdn.com/w40/pw.png'
	},
	{
		iso2: 'FM',
		name: '密克罗尼西亚',
		flag: '🇫🇲',
		code: '+691',
		placeholder: 'Enter phone number',
		format: '350 1234',
		maxLength: 7,
		pattern: /^[39]\d{6}$/,
		icon: 'https://flagcdn.com/w40/fm.png'
	},
	{
		iso2: 'MH',
		name: '马绍尔群岛',
		flag: '🇲🇭',
		code: '+692',
		placeholder: 'Enter phone number',
		format: '235 1234',
		maxLength: 7,
		pattern: /^[2-4]\d{6}$/,
		icon: 'https://flagcdn.com/w40/mh.png'
	},
	{
		iso2: 'SB',
		name: '所罗门群岛',
		flag: '🇸🇧',
		code: '+677',
		placeholder: 'Enter phone number',
		format: '74 12345',
		maxLength: 7,
		pattern: /^[7-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/sb.png'
	},
	{
		iso2: 'TV',
		name: '图瓦卢',
		flag: '🇹🇻',
		code: '+688',
		placeholder: 'Enter phone number',
		format: '901234',
		maxLength: 6,
		pattern: /^[7-9]\d{5}$/,
		icon: 'https://flagcdn.com/w40/tv.png'
	},

	// 其他非洲国家补充
	{
		iso2: 'SD',
		name: '苏丹',
		flag: '🇸🇩',
		code: '+249',
		placeholder: 'أدخل رقم الهاتف',
		format: '91 123 4567',
		maxLength: 9,
		pattern: /^9[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sd.png'
	},
	{
		iso2: 'SS',
		name: '南苏丹',
		flag: '🇸🇸',
		code: '+211',
		placeholder: 'Enter phone number',
		format: '91 123 4567',
		maxLength: 9,
		pattern: /^9[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ss.png'
	},
	{
		iso2: 'CM',
		name: '喀麦隆',
		flag: '🇨🇲',
		code: '+237',
		placeholder: 'Entrez le numéro',
		format: '6 12 34 56 78',
		maxLength: 9,
		pattern: /^6[5-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/cm.png'
	},
	{
		iso2: 'CD',
		name: '刚果民主共和国',
		flag: '🇨🇩',
		code: '+243',
		placeholder: 'Entrez le numéro',
		format: '81 123 4567',
		maxLength: 9,
		pattern: /^[89]\d{8}$/,
		icon: 'https://flagcdn.com/w40/cd.png'
	},
	{
		iso2: 'CG',
		name: '刚果共和国',
		flag: '🇨🇬',
		code: '+242',
		placeholder: 'Entrez le numéro',
		format: '06 123 4567',
		maxLength: 9,
		pattern: /^0[567]\d{7}$/,
		icon: 'https://flagcdn.com/w40/cg.png'
	},
	{
		iso2: 'CF',
		name: '中非共和国',
		flag: '🇨🇫',
		code: '+236',
		placeholder: 'Entrez le numéro',
		format: '70 12 34 56',
		maxLength: 8,
		pattern: /^7[0-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/cf.png'
	},
	{
		iso2: 'TD',
		name: '乍得',
		flag: '🇹🇩',
		code: '+235',
		placeholder: 'Entrez le numéro',
		format: '66 12 34 56',
		maxLength: 8,
		pattern: /^[679]\d{7}$/,
		icon: 'https://flagcdn.com/w40/td.png'
	},
	{
		iso2: 'NE',
		name: '尼日尔',
		flag: '🇳🇪',
		code: '+227',
		placeholder: 'Entrez le numéro',
		format: '93 12 34 56',
		maxLength: 8,
		pattern: /^[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ne.png'
	},
	{
		iso2: 'BF',
		name: '布基纳法索',
		flag: '🇧🇫',
		code: '+226',
		placeholder: 'Entrez le numéro',
		format: '70 12 34 56',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/bf.png'
	},
	{
		iso2: 'ML',
		name: '马里',
		flag: '🇲🇱',
		code: '+223',
		placeholder: 'Entrez le numéro',
		format: '65 12 34 56',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ml.png'
	},
	{
		iso2: 'SN',
		name: '塞内加尔',
		flag: '🇸🇳',
		code: '+221',
		placeholder: 'Entrez le numéro',
		format: '77 123 45 67',
		maxLength: 9,
		pattern: /^7[0-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sn.png'
	},
	{
		iso2: 'MR',
		name: '毛里塔尼亚',
		flag: '🇲🇷',
		code: '+222',
		placeholder: 'أدخل رقم الهاتف',
		format: '22 12 34 56',
		maxLength: 8,
		pattern: /^[2-4]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mr.png'
	},
	{
		iso2: 'GM',
		name: '冈比亚',
		flag: '🇬🇲',
		code: '+220',
		placeholder: 'Enter phone number',
		format: '301 2345',
		maxLength: 7,
		pattern: /^[2-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/gm.png'
	},
	{
		iso2: 'GW',
		name: '几内亚比绍',
		flag: '🇬🇼',
		code: '+245',
		placeholder: 'Digite o número',
		format: '955 123 456',
		maxLength: 9,
		pattern: /^9[5-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/gw.png'
	},
	{
		iso2: 'GN',
		name: '几内亚',
		flag: '🇬🇳',
		code: '+224',
		placeholder: 'Entrez le numéro',
		format: '601 23 45 67',
		maxLength: 9,
		pattern: /^[6]\d{8}$/,
		icon: 'https://flagcdn.com/w40/gn.png'
	},
	{
		iso2: 'SL',
		name: '塞拉利昂',
		flag: '🇸🇱',
		code: '+232',
		placeholder: 'Enter phone number',
		format: '25 123 456',
		maxLength: 8,
		pattern: /^[2-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sl.png'
	},
	{
		iso2: 'LR',
		name: '利比里亚',
		flag: '🇱🇷',
		code: '+231',
		placeholder: 'Enter phone number',
		format: '77 123 456',
		maxLength: 8,
		pattern: /^[4-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/lr.png'
	},
	{
		iso2: 'CI',
		name: '科特迪瓦',
		flag: '🇨🇮',
		code: '+225',
		placeholder: 'Entrez le numéro',
		format: '01 23 45 67 89',
		maxLength: 10,
		pattern: /^0[127]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ci.png'
	},
	{
		iso2: 'TG',
		name: '多哥',
		flag: '🇹🇬',
		code: '+228',
		placeholder: 'Entrez le numéro',
		format: '90 12 34 56',
		maxLength: 8,
		pattern: /^9[0-9]\d{6}$/,
		icon: 'https://flagcdn.com/w40/tg.png'
	},
	{
		iso2: 'BJ',
		name: '贝宁',
		flag: '🇧🇯',
		code: '+229',
		placeholder: 'Entrez le numéro',
		format: '90 12 34 56',
		maxLength: 8,
		pattern: /^[569]\d{7}$/,
		icon: 'https://flagcdn.com/w40/bj.png'
	},
	// 补充缺失的国家/地区手机号信息

	// 高加索地区
	{
		iso2: 'GE',
		name: '格鲁吉亚',
		flag: '🇬🇪',
		code: '+995',
		placeholder: 'შეიყვანეთ ტელეფონის ნომერი',
		format: '555 12 34 56',
		maxLength: 9,
		pattern: /^[57]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ge.png'
	},
	{
		iso2: 'AM',
		name: '亚美尼亚',
		flag: '🇦🇲',
		code: '+374',
		placeholder: 'Մուտքագրեք հեռախոսահամարը',
		format: '77 123 456',
		maxLength: 8,
		pattern: /^[4-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/am.png'
	},
	{
		iso2: 'AZ',
		name: '阿塞拜疆',
		flag: '🇦🇿',
		code: '+994',
		placeholder: 'Telefon nömrəsini daxil edin',
		format: '50 123 45 67',
		maxLength: 9,
		pattern: /^[4-7]\d{8}$/,
		icon: 'https://flagcdn.com/w40/az.png'
	},

	// 非洲重要国家
	{
		iso2: 'AO',
		name: '安哥拉',
		flag: '🇦🇴',
		code: '+244',
		placeholder: 'Digite o número',
		format: '923 123 456',
		maxLength: 9,
		pattern: /^9[1-3]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ao.png'
	},
	{
		iso2: 'ZM',
		name: '赞比亚',
		flag: '🇿🇲',
		code: '+260',
		placeholder: 'Enter phone number',
		format: '97 123 4567',
		maxLength: 9,
		pattern: /^9[567]\d{7}$/,
		icon: 'https://flagcdn.com/w40/zm.png'
	},
	{
		iso2: 'ZW',
		name: '津巴布韦',
		flag: '🇿🇼',
		code: '+263',
		placeholder: 'Enter phone number',
		format: '77 123 4567',
		maxLength: 9,
		pattern: /^7[1-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/zw.png'
	},
	{
		iso2: 'MU',
		name: '毛里求斯',
		flag: '🇲🇺',
		code: '+230',
		placeholder: 'Enter phone number',
		format: '5712 3456',
		maxLength: 8,
		pattern: /^[579]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mu.png'
	},
	{
		iso2: 'MZ',
		name: '莫桑比克',
		flag: '🇲🇿',
		code: '+258',
		placeholder: 'Digite o número',
		format: '82 123 4567',
		maxLength: 9,
		pattern: /^8[2-7]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mz.png'
	},
	{
		iso2: 'NA',
		name: '纳米比亚',
		flag: '🇳🇦',
		code: '+264',
		placeholder: 'Enter phone number',
		format: '81 123 4567',
		maxLength: 9,
		pattern: /^8[1-5]\d{7}$/,
		icon: 'https://flagcdn.com/w40/na.png'
	},
	{
		iso2: 'BW',
		name: '博茨瓦纳',
		flag: '🇧🇼',
		code: '+267',
		placeholder: 'Enter phone number',
		format: '71 123 456',
		maxLength: 8,
		pattern: /^7[1-8]\d{6}$/,
		icon: 'https://flagcdn.com/w40/bw.png'
	},

	// 加勒比海地区
	{
		iso2: 'BS',
		name: '巴哈马',
		flag: '🇧🇸',
		code: '+1242',
		placeholder: 'Enter phone number',
		format: '(242) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/bs.png'
	},
	{
		iso2: 'BB',
		name: '巴巴多斯',
		flag: '🇧🇧',
		code: '+1246',
		placeholder: 'Enter phone number',
		format: '(246) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/bb.png'
	},
	{
		iso2: 'AG',
		name: '安提瓜和巴布达',
		flag: '🇦🇬',
		code: '+1268',
		placeholder: 'Enter phone number',
		format: '(268) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/ag.png'
	},

	// 其他非洲国家
	{
		iso2: 'BI',
		name: '布隆迪',
		flag: '🇧🇮',
		code: '+257',
		placeholder: 'Entrez le numéro',
		format: '79 12 34 56',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/bi.png'
	},
	{
		iso2: 'DJ',
		name: '吉布提',
		flag: '🇩🇯',
		code: '+253',
		placeholder: 'Entrez le numéro',
		format: '77 12 34 56',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/dj.png'
	},
	{
		iso2: 'ER',
		name: '厄立特里亚',
		flag: '🇪🇷',
		code: '+291',
		placeholder: 'Enter phone number',
		format: '7 123 456',
		maxLength: 7,
		pattern: /^[17]\d{6}$/,
		icon: 'https://flagcdn.com/w40/er.png'
	},
	{
		iso2: 'GA',
		name: '加蓬',
		flag: '🇬🇦',
		code: '+241',
		placeholder: 'Entrez le numéro',
		format: '06 12 34 56',
		maxLength: 8,
		pattern: /^0[67]\d{6}$/,
		icon: 'https://flagcdn.com/w40/ga.png'
	},
	{
		iso2: 'KM',
		name: '科摩罗',
		flag: '🇰🇲',
		code: '+269',
		placeholder: 'Entrez le numéro',
		format: '321 12 34',
		maxLength: 7,
		pattern: /^[3]\d{6}$/,
		icon: 'https://flagcdn.com/w40/km.png'
	},
	{
		iso2: 'LS',
		name: '莱索托',
		flag: '🇱🇸',
		code: '+266',
		placeholder: 'Enter phone number',
		format: '50 123 456',
		maxLength: 8,
		pattern: /^[56]\d{7}$/,
		icon: 'https://flagcdn.com/w40/ls.png'
	},
	{
		iso2: 'MW',
		name: '马拉维',
		flag: '🇲🇼',
		code: '+265',
		placeholder: 'Enter phone number',
		format: '99 123 4567',
		maxLength: 9,
		pattern: /^[89]\d{8}$/,
		icon: 'https://flagcdn.com/w40/mw.png'
	},
	{
		iso2: 'MG',
		name: '马达加斯加',
		flag: '🇲🇬',
		code: '+261',
		placeholder: 'Entrez le numéro',
		format: '32 12 345 67',
		maxLength: 9,
		pattern: /^3[2-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mg.png'
	},
	{
		iso2: 'RW',
		name: '卢旺达',
		flag: '🇷🇼',
		code: '+250',
		placeholder: 'Injiza nimero ya terefone',
		format: '78 123 4567',
		maxLength: 9,
		pattern: /^7[2-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/rw.png'
	},
	{
		iso2: 'SC',
		name: '塞舌尔',
		flag: '🇸🇨',
		code: '+248',
		placeholder: 'Enter phone number',
		format: '2 51 23 45',
		maxLength: 7,
		pattern: /^2[5]\d{5}$/,
		icon: 'https://flagcdn.com/w40/sc.png'
	},
	{
		iso2: 'SO',
		name: '索马里',
		flag: '🇸🇴',
		code: '+252',
		placeholder: 'Enter phone number',
		format: '61 123 4567',
		maxLength: 9,
		pattern: /^[69]\d{8}$/,
		icon: 'https://flagcdn.com/w40/so.png'
	},
	{
		iso2: 'SZ',
		name: '斯威士兰',
		flag: '🇸🇿',
		code: '+268',
		placeholder: 'Enter phone number',
		format: '76 12 34 56',
		maxLength: 8,
		pattern: /^[67]\d{7}$/,
		icon: 'https://flagcdn.com/w40/sz.png'
	},
	{
		iso2: 'ST',
		name: '圣多美和普林西比',
		flag: '🇸🇹',
		code: '+239',
		placeholder: 'Digite o número',
		format: '991 2345',
		maxLength: 7,
		pattern: /^9[89]\d{5}$/,
		icon: 'https://flagcdn.com/w40/st.png'
	},
	{
		iso2: 'CV',
		name: '佛得角',
		flag: '🇨🇻',
		code: '+238',
		placeholder: 'Digite o número',
		format: '991 12 34',
		maxLength: 7,
		pattern: /^[59]\d{6}$/,
		icon: 'https://flagcdn.com/w40/cv.png'
	},

	// 更多加勒比海国家
	{
		iso2: 'DM',
		name: '多米尼克',
		flag: '🇩🇲',
		code: '+1767',
		placeholder: 'Enter phone number',
		format: '(767) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/dm.png'
	},
	{
		iso2: 'GD',
		name: '格林纳达',
		flag: '🇬🇩',
		code: '+1473',
		placeholder: 'Enter phone number',
		format: '(473) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/gd.png'
	},
	{
		iso2: 'KN',
		name: '圣基茨和尼维斯',
		flag: '🇰🇳',
		code: '+1869',
		placeholder: 'Enter phone number',
		format: '(869) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/kn.png'
	},
	{
		iso2: 'LC',
		name: '圣卢西亚',
		flag: '🇱🇨',
		code: '+1758',
		placeholder: 'Enter phone number',
		format: '(758) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/lc.png'
	},
	{
		iso2: 'VC',
		name: '圣文森特和格林纳丁斯',
		flag: '🇻🇨',
		code: '+1784',
		placeholder: 'Enter phone number',
		format: '(784) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/vc.png'
	},

	// 欧洲小国
	{
		iso2: 'AD',
		name: '安道尔',
		flag: '🇦🇩',
		code: '+376',
		placeholder: 'Introdueix el número',
		format: '312 345',
		maxLength: 6,
		pattern: /^[36]\d{5}$/,
		icon: 'https://flagcdn.com/w40/ad.png'
	},
	{
		iso2: 'SM',
		name: '圣马力诺',
		flag: '🇸🇲',
		code: '+378',
		placeholder: 'Inserisci il numero',
		format: '66 12 34 56',
		maxLength: 8,
		pattern: /^6[689]\d{6}$/,
		icon: 'https://flagcdn.com/w40/sm.png'
	},
	{
		iso2: 'VA',
		name: '梵蒂冈',
		flag: '🇻🇦',
		code: '+39',
		placeholder: 'Inserisci il numero',
		format: '06 698 12345',
		maxLength: 10,
		pattern: /^06698\d{5}$/,
		icon: 'https://flagcdn.com/w40/va.png'
	},
	{
		iso2: 'MC',
		name: '摩纳哥',
		flag: '🇲🇨',
		code: '+377',
		placeholder: 'Entrez le numéro',
		format: '6 12 34 56 78',
		maxLength: 9,
		pattern: /^[46]\d{8}$/,
		icon: 'https://flagcdn.com/w40/mc.png'
	},
	{
		iso2: 'LI',
		name: '列支敦士登',
		flag: '🇱🇮',
		code: '+423',
		placeholder: 'Telefonnummer eingeben',
		format: '660 12 34',
		maxLength: 7,
		pattern: /^[67]\d{6}$/,
		icon: 'https://flagcdn.com/w40/li.png'
	},

	// 海外领土和小岛屿（低优先级）
	{
		iso2: 'AI',
		name: '安圭拉',
		flag: '🇦🇮',
		code: '+1264',
		placeholder: 'Enter phone number',
		format: '(264) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/ai.png'
	},
	{
		iso2: 'AW',
		name: '阿鲁巴',
		flag: '🇦🇼',
		code: '+297',
		placeholder: 'Enter phone number',
		format: '560 1234',
		maxLength: 7,
		pattern: /^[56]\d{6}$/,
		icon: 'https://flagcdn.com/w40/aw.png'
	},
	{
		iso2: 'CW',
		name: '库拉索',
		flag: '🇨🇼',
		code: '+599',
		placeholder: 'Enter phone number',
		format: '9 512 3456',
		maxLength: 8,
		pattern: /^9[5-7]\d{6}$/,
		icon: 'https://flagcdn.com/w40/cw.png'
	},
	{
		iso2: 'SX',
		name: '荷属圣马丁',
		flag: '🇸🇽',
		code: '+1721',
		placeholder: 'Enter phone number',
		format: '(721) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/sx.png'
	},
	{
		iso2: 'BQ',
		name: '荷兰加勒比区',
		flag: '🇧🇶',
		code: '+599',
		placeholder: 'Enter phone number',
		format: '7 12 34 56',
		maxLength: 7,
		pattern: /^[37]\d{6}$/,
		icon: 'https://flagcdn.com/w40/bq.png'
	},
	{
		iso2: 'VG',
		name: '英属维尔京群岛',
		flag: '🇻🇬',
		code: '+1284',
		placeholder: 'Enter phone number',
		format: '(284) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/vg.png'
	},
	{
		iso2: 'VI',
		name: '美属维尔京群岛',
		flag: '🇻🇮',
		code: '+1340',
		placeholder: 'Enter phone number',
		format: '(340) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/vi.png'
	},
	{
		iso2: 'TC',
		name: '特克斯和凯科斯群岛',
		flag: '🇹🇨',
		code: '+1649',
		placeholder: 'Enter phone number',
		format: '(649) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/tc.png'
	},
	{
		iso2: 'BM',
		name: '百慕大',
		flag: '🇧🇲',
		code: '+1441',
		placeholder: 'Enter phone number',
		format: '(441) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/bm.png'
	},

	// 太平洋地区美国领土
	{
		iso2: 'AS',
		name: '美属萨摩亚',
		flag: '🇦🇸',
		code: '+1684',
		placeholder: 'Enter phone number',
		format: '(684) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/as.png'
	},
	{
		iso2: 'GU',
		name: '关岛',
		flag: '🇬🇺',
		code: '+1671',
		placeholder: 'Enter phone number',
		format: '(671) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/gu.png'
	},
	{
		iso2: 'MP',
		name: '北马里亚纳群岛',
		flag: '🇲🇵',
		code: '+1670',
		placeholder: 'Enter phone number',
		format: '(670) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/mp.png'
	},
	{
		iso2: 'WF',
		name: '瓦利斯和富图纳',
		flag: '🇼🇫',
		code: '+681',
		placeholder: 'Entrez le numéro',
		format: '12 34 56',
		maxLength: 6,
		pattern: /^[5-8]\d{5}$/,
		icon: 'https://flagcdn.com/w40/wf.png'
	},
	// 最终补充的35个缺失地区手机号信息

	// 北欧自治区
	{
		iso2: 'FO',
		name: '法罗群岛',
		flag: '🇫🇴',
		code: '+298',
		placeholder: 'Skriva telefontal',
		format: '21 23 45',
		maxLength: 6,
		pattern: /^[2-9]\d{5}$/,
		icon: 'https://flagcdn.com/w40/fo.png'
	},
	{
		iso2: 'GL',
		name: '格陵兰',
		flag: '🇬🇱',
		code: '+299',
		placeholder: 'Skriv telefonnummer',
		format: '22 34 56',
		maxLength: 6,
		pattern: /^[2-9]\d{5}$/,
		icon: 'https://flagcdn.com/w40/gl.png'
	},
	{
		iso2: 'AX',
		name: '奥兰群岛',
		flag: '🇦🇽',
		code: '+358',
		placeholder: 'Skriv telefonnummer',
		format: '18 123 4567',
		maxLength: 9,
		pattern: /^18\d{7}$/,
		icon: 'https://flagcdn.com/w40/ax.png'
	},

	// 英国皇家属地
	{
		iso2: 'IM',
		name: '马恩岛',
		flag: '🇮🇲',
		code: '+44',
		placeholder: 'Enter phone number',
		format: '1624 123456',
		maxLength: 10,
		pattern: /^1624\d{6}$/,
		icon: 'https://flagcdn.com/w40/im.png'
	},
	{
		iso2: 'JE',
		name: '泽西岛',
		flag: '🇯🇪',
		code: '+44',
		placeholder: 'Enter phone number',
		format: '1534 123456',
		maxLength: 10,
		pattern: /^1534\d{6}$/,
		icon: 'https://flagcdn.com/w40/je.png'
	},
	{
		iso2: 'GG',
		name: '根西岛',
		flag: '🇬🇬',
		code: '+44',
		placeholder: 'Enter phone number',
		format: '1481 123456',
		maxLength: 10,
		pattern: /^1481\d{6}$/,
		icon: 'https://flagcdn.com/w40/gg.png'
	},

	// 英国海外领土
	{
		iso2: 'GI',
		name: '直布罗陀',
		flag: '🇬🇮',
		code: '+350',
		placeholder: 'Enter phone number',
		format: '5412 3456',
		maxLength: 8,
		pattern: /^[56]\d{7}$/,
		icon: 'https://flagcdn.com/w40/gi.png'
	},
	{
		iso2: 'FK',
		name: '福克兰群岛',
		flag: '🇫🇰',
		code: '+500',
		placeholder: 'Enter phone number',
		format: '5123 4',
		maxLength: 5,
		pattern: /^[56]\d{4}$/,
		icon: 'https://flagcdn.com/w40/fk.png'
	},
	{
		iso2: 'SH',
		name: '圣赫勒拿岛',
		flag: '🇸🇭',
		code: '+290',
		placeholder: 'Enter phone number',
		format: '2 234',
		maxLength: 4,
		pattern: /^[2-9]\d{3}$/,
		icon: 'https://flagcdn.com/w40/sh.png'
	},
	{
		iso2: 'AC',
		name: '阿森松岛',
		flag: '🇦🇨',
		code: '+247',
		placeholder: 'Enter phone number',
		format: '6 123',
		maxLength: 4,
		pattern: /^[6]\d{3}$/,
		icon: 'https://flagcdn.com/w40/ac.png'
	},
	{
		iso2: 'TA',
		name: '特里斯坦达库尼亚',
		flag: '🇹🇦',
		code: '+290',
		placeholder: 'Enter phone number',
		format: '8 123',
		maxLength: 4,
		pattern: /^8\d{3}$/,
		icon: 'https://flagcdn.com/w40/ta.png'
	},
	{
		iso2: 'MS',
		name: '蒙特塞拉特',
		flag: '🇲🇸',
		code: '+1664',
		placeholder: 'Enter phone number',
		format: '(664) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/ms.png'
	},
	{
		iso2: 'KY',
		name: '开曼群岛',
		flag: '🇰🇾',
		code: '+1345',
		placeholder: 'Enter phone number',
		format: '(345) 123-4567',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/ky.png'
	},
	{
		iso2: 'PN',
		name: '皮特凯恩群岛',
		flag: '🇵🇳',
		code: '+64',
		placeholder: 'Enter phone number',
		format: '64 123',
		maxLength: 5,
		pattern: /^64\d{3}$/,
		icon: 'https://flagcdn.com/w40/pn.png'
	},
	{
		iso2: 'IO',
		name: '英属印度洋领地',
		flag: '🇮🇴',
		code: '+246',
		placeholder: 'Enter phone number',
		format: '380 1234',
		maxLength: 7,
		pattern: /^3[78]\d{5}$/,
		icon: 'https://flagcdn.com/w40/io.png'
	},

	// 法国海外领土
	{
		iso2: 'GP',
		name: '瓜德罗普',
		flag: '🇬🇵',
		code: '+590',
		placeholder: 'Entrez le numéro',
		format: '690 12 34 56',
		maxLength: 9,
		pattern: /^6[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/gp.png'
	},
	{
		iso2: 'MQ',
		name: '马提尼克',
		flag: '🇲🇶',
		code: '+596',
		placeholder: 'Entrez le numéro',
		format: '696 12 34 56',
		maxLength: 9,
		pattern: /^6[89]\d{7}$/,
		icon: 'https://flagcdn.com/w40/mq.png'
	},
	{
		iso2: 'RE',
		name: '留尼汪',
		flag: '🇷🇪',
		code: '+262',
		placeholder: 'Entrez le numéro',
		format: '692 12 34 56',
		maxLength: 9,
		pattern: /^6[9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/re.png'
	},
	{
		iso2: 'YT',
		name: '马约特',
		flag: '🇾🇹',
		code: '+262',
		placeholder: 'Entrez le numéro',
		format: '639 12 34 56',
		maxLength: 9,
		pattern: /^639\d{6}$/,
		icon: 'https://flagcdn.com/w40/yt.png'
	},
	{
		iso2: 'BL',
		name: '圣巴泰勒米',
		flag: '🇧🇱',
		code: '+590',
		placeholder: 'Entrez le numéro',
		format: '690 12 34 56',
		maxLength: 9,
		pattern: /^690\d{6}$/,
		icon: 'https://flagcdn.com/w40/bl.png'
	},
	{
		iso2: 'MF',
		name: '法属圣马丁',
		flag: '🇲🇫',
		code: '+590',
		placeholder: 'Entrez le numéro',
		format: '690 12 34 56',
		maxLength: 9,
		pattern: /^690\d{6}$/,
		icon: 'https://flagcdn.com/w40/mf.png'
	},
	{
		iso2: 'PM',
		name: '圣皮埃尔和密克隆',
		flag: '🇵🇲',
		code: '+508',
		placeholder: 'Entrez le numéro',
		format: '55 12 34',
		maxLength: 6,
		pattern: /^[45]\d{5}$/,
		icon: 'https://flagcdn.com/w40/pm.png'
	},
	{
		iso2: 'TF',
		name: '法属南部和南极领地',
		flag: '🇹🇫',
		code: '+262',
		placeholder: 'Entrez le numéro',
		format: '262 12 34 56',
		maxLength: 9,
		pattern: /^262\d{6}$/,
		icon: 'https://flagcdn.com/w40/tf.png'
	},

	// 美国海外领土
	{
		iso2: 'UM',
		name: '美国本土外小岛屿',
		flag: '🇺🇲',
		code: '+1',
		placeholder: 'Enter phone number',
		format: '(xxx) xxx-xxxx',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/um.png'
	},

	// 澳大利亚海外领土
	{
		iso2: 'NF',
		name: '诺福克岛',
		flag: '🇳🇫',
		code: '+672',
		placeholder: 'Enter phone number',
		format: '3 12345',
		maxLength: 6,
		pattern: /^3\d{5}$/,
		icon: 'https://flagcdn.com/w40/nf.png'
	},
	{
		iso2: 'CX',
		name: '圣诞岛',
		flag: '🇨🇽',
		code: '+61',
		placeholder: 'Enter phone number',
		format: '8 9164 1234',
		maxLength: 9,
		pattern: /^89164\d{4}$/,
		icon: 'https://flagcdn.com/w40/cx.png'
	},
	{
		iso2: 'CC',
		name: '科科斯(基林)群岛',
		flag: '🇨🇨',
		code: '+61',
		placeholder: 'Enter phone number',
		format: '8 9162 1234',
		maxLength: 9,
		pattern: /^89162\d{4}$/,
		icon: 'https://flagcdn.com/w40/cc.png'
	},
	{
		iso2: 'HM',
		name: '赫德岛和麦克唐纳群岛',
		flag: '🇭🇲',
		code: '+672',
		placeholder: 'Enter phone number',
		format: '1 12345',
		maxLength: 6,
		pattern: /^1\d{5}$/,
		icon: 'https://flagcdn.com/w40/hm.png'
	},

	// 挪威海外领土
	{
		iso2: 'SJ',
		name: '斯瓦尔巴和扬马延',
		flag: '🇸🇯',
		code: '+47',
		placeholder: 'Skriv inn telefonnummer',
		format: '79 123 456',
		maxLength: 8,
		pattern: /^79\d{6}$/,
		icon: 'https://flagcdn.com/w40/sj.png'
	},
	{
		iso2: 'BV',
		name: '布韦岛',
		flag: '🇧🇻',
		code: '+47',
		placeholder: 'Uninhabited island',
		format: 'No phone service',
		maxLength: 0,
		pattern: /^$/,
		icon: 'https://flagcdn.com/w40/bv.png'
	},

	// 争议地区
	{
		iso2: 'XK',
		name: '科索沃',
		flag: '🇽🇰',
		code: '+383',
		placeholder: 'Shkruani numrin e telefonit',
		format: '44 123 456',
		maxLength: 8,
		pattern: /^[4-9]\d{7}$/,
		icon: 'https://flagcdn.com/w40/xk.png'
	},
	{
		iso2: 'EH',
		name: '西撒哈拉',
		flag: '🇪🇭',
		code: '+212',
		placeholder: 'أدخل رقم الهاتف',
		format: '528 123 456',
		maxLength: 9,
		pattern: /^528\d{6}$/,
		icon: 'https://flagcdn.com/w40/eh.png'
	},

	// 特殊地区
	{
		iso2: 'AQ',
		name: '南极洲',
		flag: '🇦🇶',
		code: '+672',
		placeholder: 'Research stations only',
		format: '1 12345',
		maxLength: 6,
		pattern: /^1\d{5}$/,
		icon: 'https://flagcdn.com/w40/aq.png'
	},

	// 西班牙海外领土
	{
		iso2: 'IC',
		name: '加那利群岛',
		flag: '🇮🇨',
		code: '+34',
		placeholder: 'Introduce el número',
		format: '6xx xx xx xx',
		maxLength: 9,
		pattern: /^[67]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ic.png'
	},
	{
		iso2: 'EA',
		name: '休达和梅利利亚',
		flag: '🇪🇦',
		code: '+34',
		placeholder: 'Introduce el número',
		format: '6xx xx xx xx',
		maxLength: 9,
		pattern: /^[67]\d{8}$/,
		icon: 'https://flagcdn.com/w40/ea.png'
	},
	// 最后补充的3个缺失条目

	// 荷兰海外领土（历史）
	{
		iso2: 'AN',
		name: '荷属安的列斯',
		flag: '🇦🇳',
		code: '+599',
		placeholder: 'Enter phone number',
		format: '9 123 4567',
		maxLength: 8,
		pattern: /^[79]\d{7}$/,
		icon: 'https://flagcdn.com/w40/an.png'
	},

	// 国际组织
	{
		iso2: 'UN',
		name: '联合国',
		flag: '🇺🇳',
		code: '+1',
		placeholder: 'UN offices use local codes',
		format: 'Varies by location',
		maxLength: 10,
		pattern: /^\d{10}$/,
		icon: 'https://flagcdn.com/w40/un.png'
	},

	// 国际特殊服务
	{
		iso2: 'IF',
		name: '国际免费电话',
		flag: '📞',
		code: '+800',
		placeholder: 'International toll-free',
		format: '1234 5678',
		maxLength: 8,
		pattern: /^\d{8}$/,
		icon: null
	}
];

export default countries;